import { defineStore } from 'pinia'
import { mergeOptionsParams, useCreateForm, useEditForm } from "@/stores/_helpers.js";
import toasteventbus from "primevue/toasteventbus";

export const useRegulationsStore = defineStore('regulations', {
  state: () => ({
    data: undefined,
    allData: undefined,
    options: undefined,
  }),
  getters: {
    getRegulations: (state) => state.data?.data,
    getRegulationOptions: (state) => state.options?.data ?? [],
    getAllRegulations: (state) => state.allData?.data,
  },
  actions: {
    /**
     * This method should be used to return as little data as possible for use in select boxes
     *
     * @param params
     * @param silent
     * @returns {Promise<any>}
     */
    async indexRegulationOptions(params = {}, silent = true) {

      if (!silent)
        this.options = undefined;

      try {
        if (!this.options) {
          let qryParams = mergeOptionsParams(params, 'regulations', ['id', 'name', 'description']);
          const response = await axios.get('regulations', {params: qryParams});
          this.options = response.data;
        }

        return this.options;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },

    async indexRegulations(params = {}) {
      try {
        const response = await axios.get('regulations', {params});
        this.data = response.data;
        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async indexAllRegulations(params = {}, silent = true) {
      if (!silent)
        this.allData = undefined;

      if (this.allData === undefined) {
        try {
          const response = await axios.get('regulations/all', {params});
          this.allData = response.data;
          return response.data;
        } catch (error) {
          console.error(error.response);
          throw error.response;
        }
      }

      return this.allData;
    },
    async createRegulation(params = {}) {
      try {
        const response = await axios.get('regulations/create', {params});
        return useCreateForm('regulations', response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async showRegulation(regulationId, params = {}) {
      try {
        const response = await axios.get(`regulations/${ regulationId }`, {params});
        console.log(response)

        return response.data;
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async editRegulation(regulationId, params = {}) {
      try {
        const response = await axios.get(`regulations/${ regulationId }/edit`, {params});
        return useEditForm(`regulations/${ regulationId }`, response.data);
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
    async deleteRegulation(regulationId, params = {}) {
      try {
        const response = await axios.delete(`regulations/${ regulationId }`, {params});
        toasteventbus.emit('add', {
          summary: 'Regulation Deleted',
          detail: `Regulation has been deleted.`,
          severity: 'success',
          life: 3000
        });
      } catch (error) {
        console.error(error.response);
        throw error.response;
      }
    },
  },
});
